import { constructEnum } from '@/lib/enum';

export default constructEnum('PreferredFitType', {
  SLIM: 'slim',
  BASIC: 'basic',
  LOOSE: 'loose'
});
